import React, { useRef, useState } from "react";
import PresupuestoTemplate from "../../components/presupuesto/PresupuestoTemplate";
import PresupuestoForm from "../../components/presupuesto/PresupuestoForm";
import { defaultConfig } from "../../utils/presupuestoCalc";
import { generarPresupuestoPdf } from "../../utils/presupuestoPdf";
import { colors } from "../../utils/designTokens";

// Pantalla de generacion de presupuestos comerciales (admin / superadmin).
// Layout split: preview del documento a la izquierda, formulario controlado a la derecha.
// El estado vive aca; los cambios del form actualizan el preview en vivo.
// El boton "Generar PDF" captura el template via html2canvas y descarga un .pdf de 6 paginas A4.

export default function Presupuestos() {
  const [config, setConfig] = useState(() => defaultConfig());
  const [generating, setGenerating] = useState(false);
  const templateRef = useRef(null);

  const handleGenerar = async () => {
    if (generating) return;
    setGenerating(true);
    try {
      const safeNombre = (config.edificio || "Presupuesto").replace(/[^\w\sáéíóúÁÉÍÓÚñÑ-]/g, "").trim();
      const filename = `Presupuesto Habitia - ${safeNombre} - ${config.propuestaNro}.pdf`;
      await generarPresupuestoPdf(templateRef.current, filename, { download: true });
    } catch (err) {
      console.error("Error generando PDF:", err);
      alert("No se pudo generar el PDF. Revisá la consola para detalles.");
    } finally {
      setGenerating(false);
    }
  };

  return (
    <div style={S.container}>
      <main style={S.previewArea}>
        <div style={S.previewInner}>
          <PresupuestoTemplate ref={templateRef} config={config} />
        </div>
      </main>
      <PresupuestoForm
        config={config}
        onChange={setConfig}
        onGenerarPdf={handleGenerar}
        generating={generating}
      />
    </div>
  );
}

const S = {
  container: {
    display: "flex",
    height: "100%",
    minHeight: 0,
    background: "#E9EBEE",
    fontFamily: "'FT Habit', -apple-system, BlinkMacSystemFont, sans-serif",
    fontWeight: 400,
  },
  previewArea: {
    flex: 1,
    minWidth: 0,
    overflow: "auto",
  },
  previewInner: {
    minWidth: "fit-content",
  },
};
